import { TextFilterType } from '../../../../../types';

export const enum UniversalFilterTextModes {
  CONTAINS = 'contains',
  IS = 'is',
  IS_NOT = 'is_not',
  STARTS_WITH = 'starts_with',
  ENDS_WITH = 'ends_with',
  IS_EMPTY = 'is_empty',
  IS_NOT_EMPTY = 'is_not_empty'
}

export type UniversalFilterTextValue = TextFilterType;

export type UniversalFilterTextFilterState = {
  mode: UniversalFilterTextModes;
  text?: string;
};

export type UniversalFilterTextFilterOptions = {
  availableModes: UniversalFilterTextModes[];
};

export type UniversalFilterTextOnFilterStateChange = (
  state: UniversalFilterTextFilterState
) => void;

export type UniversalFilterTextOnChange = (
  value?: UniversalFilterTextValue
) => void;
